package pt.at.oss.kotlin.manual.validator.intermediaryform

import pt.at.oss.kotlin.manual.schema.intermediaryForm.IntermediaryFormSchema
import pt.at.oss.kotlin.manual.storage.intermediaryForm.IntermediaryForm
import pt.at.oss.kotlin.manual.validator.common.AddressValidator
import pt.at.oss.kotlin.manual.validator.common.BankAccountInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactNameValidator
import pt.at.oss.kotlin.manual.validator.common.CountryOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator.Type.ESTABLISHMENT
import pt.at.oss.kotlin.manual.validator.common.FreeTextValidator
import pt.at.oss.kotlin.manual.validator.common.PREV_OR_CURR_OSS_INT_IDS_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.TradingNamesValidator
import pt.lightweightform.kotlin.type.validator.ValidationError
import pt.lightweightform.kotlin.type.validator.ValidationErrors

/**
 * Created by João Cruz.
 */
class IntermediaryFormValidator {

    fun validate(model: IntermediaryForm): ValidationErrors {
        val schemaErrors = IntermediaryFormSchema().validate(model)

        if (schemaErrors.errors.isNotEmpty()) {
            return schemaErrors
        } else {
            val extraErrors = mutableListOf<ValidationError>()

            // companyName
            // ->required and has max size
            FreeTextValidator.validateFreeText(model.companyName)
                ?.also { extraErrors.add(it) }

            // tradingNames
            TradingNamesValidator.tradingNamesValidate(model.tradingNames.size, model.companyName)
                ?.also { extraErrors.add(it) }
            extraErrors.addAll(model.tradingNames.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

            // countryOfBusiness
            extraErrors.addAll(CountryOfBusinessValidator().validateSequencial(model.countryOfBusiness!!, model.cobRegion, false, true))

            // address
            extraErrors.addAll(AddressValidator().validateAddressSequencial(model.address))

            // websites
            // -> does not exist for intermediaries

            // contactName
            extraErrors.addAll(ContactNameValidator.contactNameSequencialValidate(model.contactName))

            // contactInfo
            extraErrors.addAll(ContactInfoValidator.contactInfoSequencialValidate(model.contactInfo))

            // bankAccountInfo
            extraErrors.addAll(BankAccountInfoValidator.bankAccountInfoSequencialValidate(model.bankAccountInfo, false, true))

            // fixedEstablishments
            extraErrors.addAll(
                FixedEstablishmentsValidator().validateFixedEstablishmentsSequencial(
                    model.fixedEstablishments,
                    listOf(
                        ESTABLISHMENT
                    )
                )
            )

            // prevOrCurrOssVatId isoA2 and vat
            model.prevOrCurrOssVatId.forEach { prevOrCurrOssVatId ->
                extraErrors.addAll(PREV_OR_CURR_OSS_INT_IDS_VALIDATOR.validateVatIdSequencial(prevOrCurrOssVatId))
            }

            return ValidationErrors(extraErrors)
        }
    }
}
